import { Component } from "react";
import { decode as base64_decode } from "base-64";
import { Card, Col, Row, Space, Button, Spin } from "antd";
import { Column } from "@ant-design/plots";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import Cookies from "universal-cookie";
import AIDashboardStore from "../store/AIDashboardStore";
import AiAlarmReportStore from "../store/AiAlarmReportStore";

import {
  BellOutlined,
  MobileOutlined,
  CarOutlined,
  UserOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

import "../assets/css/aidashboard.css";
import dayjs from "dayjs";
import {
  ResponsiveContainer,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  Line,
  Legend,
} from "recharts";

class AIDashboard extends Component {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();
    this.aiDashboardStore = new AIDashboardStore();
    this.AiAlarmReportStore = new AiAlarmReportStore();

    this.barData = [
      { status: "Stopped", count: this.aiDashboardStore.vstop },
      { status: "Idling", count: this.aiDashboardStore.vidle },
      { status: "Running", count: this.aiDashboardStore.vmove },
      { status: "Offline", count: this.aiDashboardStore.vnodata },
    ];

    this.lineData = Array.from({ length: 24 }, (_, i) => ({
      hour: `${i + 1}`,
      value: Math.floor(Math.random() * 10) + 1,
    }));

    this.barConfig = {
      data: this.barData,
      xField: "count",
      yField: "status",
      seriesField: "status",
      color: ({ status }) => {
        if (status === "Stopped") return "#ff4d4f";
        if (status === "Idling") return "#faad14";
        if (status === "Running") return "#52c41a";
        if (status === "Offline") return "#000000";
        return "#1890ff";
      },
      legend: false,
      barWidthRatio: 0.5,
      height: 300,
    };

    this.lineConfig = {
      data: this.lineData,
      xField: "hour",
      yField: "value",
      smooth: true,
      height: 300,
      lineStyle: {
        stroke: "#52c41a",
      },
      point: {
        size: 5,
        shape: "circle",
      },
    };

    this.mockData = [
      { name: "Device A", value: 2000 },
      { name: "Device B", value: 1300 },
      { name: "Device C", value: 900 },
      { name: "Device D", value: 400 },
      { name: "Device E", value: 150 },
    ];

    this.state = {
      animatedValues: this.mockData.map(() => 0),
      data3: [],
      filterValue: "week",
      loadData: 0,
    };

    this.bar3 = [
      { letter: "A", frequency: 8167 },
      { letter: "B", frequency: 1492 },
      { letter: "C", frequency: 2782 },
      { letter: "D", frequency: 4253 },
      { letter: "E", frequency: 12702 },
      { letter: "F", frequency: 2288 },
      { letter: "G", frequency: 2015 },
      { letter: "H", frequency: 6094 },
      { letter: "I", frequency: 6966 },
      { letter: "J", frequency: 153 },
    ];
  }

  async loadDashboardData(filterValue) {
    const companyId = JSON.parse(
      base64_decode(this.cookies.get("data"))
    ).userCompanyId;
    const userId = JSON.parse(base64_decode(this.cookies.get("data"))).userId;
    const isadmin = JSON.parse(base64_decode(this.cookies.get("data"))).isadmin;
    // const filterValue = "month";
    // const fromDate = "2025-06-11";
    // const toDate = "2025-05-11";
    // const date = "2025-05-11";

    const currentDate = dayjs().format("YYYY-MM-DD");
    const previousWeekDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
    const previousMonthDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
    const toDate = currentDate;
    const fromDate =
      filterValue === "Today"
        ? currentDate
        : filterValue === "month"
          ? previousMonthDate
          : previousWeekDate;
    const date = currentDate;
    await this.aiDashboardStore.loadData({
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      filterValue: filterValue ? filterValue : "week",
      fromDate: fromDate,
      toDate: toDate,
      date: date,
    });

    await this.aiDashboardStore.getGraphData({
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      filterValue: filterValue ? filterValue : "week",
      fromDate: fromDate,
      toDate: toDate,
      date: date,
    });
  }

  async componentDidMount() {
    await this.loadDashboardData();
    this.statuses = [
      {
        label: "Stopped",
        color: "#f44336",
        count: this.aiDashboardStore.vstop,
      },
      { label: "Idling", color: "#ffc107", count: this.aiDashboardStore.vidle },
      {
        label: "Running",
        color: "#4caf50",
        count: this.aiDashboardStore.vmove,
      },
      {
        label: "Offline",
        color: "#000000",
        count: this.aiDashboardStore.vnodata,
      },
    ];

    this.interval = setInterval(() => {
      this.setState((prevState) => {
        const updatedValues = prevState.animatedValues.map((val, index) => {
          const target = this.mockData[index].value;
          const increment = target / 30;
          return val + increment >= target ? target : val + increment;
        });
        return { animatedValues: updatedValues };
      });
    }, 30);

    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://render.alipay.com/p/yuyan/180020010001215413/antd-charts/column-column.json"
        );
        const json = await response.json();
        //  console.log(json);
        this.setState({ data3: json });
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();

    this.setState({ loadData: 1 });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  renderCustomLegend = (props) => {
    const { payload } = props;
    return (
      <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
        {payload.map((entry, index) => (
          <div
            key={`item-${index}`}
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                width: 25,
                height: 12,
                // backgroundColor: entry.color,
                border: `2px solid ${entry.color}`,
                marginRight: 8,
              }}
            />
            <span>{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };
  aialarmreport = (rec) => {
    console.log(rec)
    var companyId = JSON.parse(base64_decode(this.cookies.get("data"))).userId
    var fromDate = ""
    if (this.state.filterValue === "Today") {
      fromDate = dayjs().format("YYYY-MM-DD");
    } else if (this.state.filterValue === "month") {
      fromDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
    } else {
      fromDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");

    }
    this.context.viewStateStore.setAiDahboardStates({
      companyId: companyId, alarmId: rec.alarmId, fromDate: fromDate, toDate: dayjs().format("YYYY-MM-DD"),
    });
    console.log("setAlarmReportList", this.context.viewStateStore.aiDashboardObject);
    this.props.navigate("/aialarmreportlist");

  }

  render() {
    const deviceAlarmGraph = {
      data: this.aiDashboardStore.deviceAlarmGraph.map(item => ({
        ...item,
        count: Number(item.count), // Ensure it's a number
      })),

      xField: "vehNo",
      yField: "count",

      animation: false,
      autoFit: false,                
      columnWidthRatio: 0.3,
      minColumnWidth: 30,          
      maxColumnWidth: 50,

      columnStyle: {
        radius: [10, 10, 0, 0],
      },


      yAxis: {
        min: 0,
        max: 2000,
        tickInterval: 500,
        tickMethod: () => [0, 500, 1000, 1500, 2000],
        label: {
          formatter: (val) => `${val}`,
          style: {
            fontSize: 14,
            fill: "#666",
          },
        },
        grid: {
          line: {
            style: {
              stroke: '#ccc',
              lineDash: [4, 4],
            },
          },
        },
      },

      xAxis: {
        label: {
          autoHide: false,
          autoRotate: false,
          style: {
            fontSize: 14,
          },
        },
      },

      tooltip: false,
    };
    ;

    const maxSpeedGraph = {
      data: this.aiDashboardStore.MaxSpeedGraph.map(item => ({
        ...item,
        maxSpeed: Number(item.maxSpeed),
      })),

      xField: "vehNo",
      yField: "maxSpeed",

      autoFit: false, // Don't shrink chart inside scroll wrapper

      animation: false,
      columnWidthRatio: 0.3,
      minColumnWidth: 30,
      maxColumnWidth: 50,

      columnStyle: {
        radius: [10, 10, 0, 0],
      },

      color: '#00D897',

      yAxis: {
        min: 0,
        max: 300,
        tickInterval: 60,
        tickMethod: () => [0, 60, 120, 180, 240],
        label: {
          formatter: (val) => `${val}`,
          style: {
            fontSize: 14,
            fill: "#666",
          },
        },
        grid: {
          line: {
            style: {
              stroke: '#ccc',
              lineDash: [4, 4],
            },
          },
        },
      },

      xAxis: {
        label: {
          autoHide: false,
          autoRotate: false,
          style: {
            fontSize: 14,
          },
        },
      },

      tooltip: false,
    };



    const data = this.aiDashboardStore.dashboardCount;


    const {
      deviceCount = 0,
      fleetCount = 0,
      usersCount = 0,
      alarmCount = 0,
    } = data || {};
    //  console.log("dashboardCount:", this.aiDashboardStore.dashboardCount);

    //  console.log(deviceCount, fleetCount, usersCount, alarmCount);
    return (
      <Spin spinning={this.aiDashboardStore.loading} fullscreen>
        <div className="aidashboard-container">
          <Row gutter={[16, 16]} className="dashboard-header">
            <Card className="aidashtop-card aidashboard-card">
              <MobileOutlined className="card-icon" />{" "}
              <span className="count">{deviceCount}</span>{" "}
              {this.context.translate("_DEVICES_")}
            </Card>
            <Card className="aidashtop-card aidashboard-card">
              <CarOutlined className="card-icon" />{" "}
              <span className="count">{fleetCount}</span>{" "}
              {this.context.translate("_FLEETS_")}
            </Card>
            <Card className="aidashtop-card aidashboard-card">
              <UserOutlined className="card-icon" />{" "}
              <span className="count">{usersCount}</span>{" "}
              {this.context.translate("_USERS_")}
            </Card>
            <Card className="aidashtop-card aidashboard-card">
              <BellOutlined className="card-icon" />{" "}
              <span className="count">{alarmCount}</span>{" "}
              {this.context.translate("_ALARMS_")}
            </Card>
            <Card span={4} className="refresh-button" style={{ padding: "20px" }}>
              <Button icon={<ReloadOutlined />} />
            </Card>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12}></Col>

            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: "10px",
              }}
            >
              <Space>
                {" "}
                <Button
                  className={
                    this.state.filterValue === "Today"
                      ? "activeButtonColor"
                      : "buttonColor"
                  }
                  onClick={() => {
                    this.loadDashboardData("Today");
                    this.setState({ filterValue: "Today" });
                  }}
                >
                  {this.context.translate("_TODAY_")}
                </Button>
                <Button
                  className={
                    this.state.filterValue === "week"
                      ? "activeButtonColor"
                      : "buttonColor"
                  }
                  onClick={() => {
                    this.loadDashboardData("week");
                    this.setState({ filterValue: "week" });
                  }}
                >
                  {this.context.translate("_FLEET_RULELIST_CRONRULE_WEEKLY_")}
                </Button>
                <Button
                  className={
                    this.state.filterValue === "month"
                      ? "activeButtonColor"
                      : "buttonColor"
                  }
                  onClick={() => {
                    this.loadDashboardData("month");
                    this.setState({ filterValue: "month" });
                  }}
                >
                  {this.context.translate("_MONTHLY_")}
                </Button>
              </Space>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="graph-section">
            <Col span={8}>
              <div className="device-status-container">
                <h3>{this.context.translate("_DEVICE_ONLINE_STATICS_")}</h3>
                <div className="status-content">
                  <div className="status-bar">
                    {this.aiDashboardStore.statuses.map((status, index) => (
                      <div
                        key={index}
                        className="status-segment"
                        style={{
                          backgroundColor: status.color,
                          flexGrow: status.count,
                        }}
                      />
                    ))}
                  </div>
                  <div className="status-details">
                    {this.aiDashboardStore.statuses.map((status, index) => (
                      <div key={index} className="status-item">
                        <span
                          className="status-dot"
                          style={{ backgroundColor: status.color }}
                        ></span>
                        <span className="status-label">{status.label}</span>
                        <span className="status-count">{status.count}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>

            <Col span={16}>
              <Card
                className="line-graph device-alarm-container"
                style={{ padding: "16px" }}
              >
                <h3>{this.context.translate("_ALERT_TREND_")}</h3>
                <ResponsiveContainer height={500}>
                  <LineChart
                    width={500}
                    height={400}
                    data={this.aiDashboardStore.alertTrend}
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      content={this.renderCustomLegend}
                    />

                    <Line
                      type="monotone"
                      dataKey="AI"
                      stroke="green"
                      fill="green"
                      dot={{ fill: "green" }}
                    />
                    <Line
                      type="monotone"
                      dataKey="Normal"
                      stroke="#157fcc"
                      fill="#157fcc"
                      dot={{ fill: "#157fcc" }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Card>
            </Col>
          </Row>

          <Row
            gutter={[16, 16]}
            className="graph-section"
            style={{ marginTop: "20px" }}
          >
            <Col span={12}>
              <div className="device-status-container">
                <h3>{this.context.translate("_ALARMS_")}</h3>
                <div className="alarm-list">
                  {this.aiDashboardStore.alarmData.map((status, index) => (
                    <div className="alarm-item" onClick={() => this.aialarmreport(status)}>
                      <div className="d-flex gap-2 align-items-center">
                        <div className="inblueline"></div>
                        <span className="alarm-label">{status.alarmName}</span>
                      </div>
                      <span className="alarm-count">{status.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="device-alarmrank-container">
                <h3>{this.context.translate("_DEVICE_ALARM_RANKING_")}</h3>
                <div className="chart-scroll-wrapper">
                  <Column {...deviceAlarmGraph} />

                </div>
              </div>
            </Col>
          </Row>

          <Row
            gutter={[16, 16]}
            className="graph-section"
            style={{ marginTop: "20px", marginBottom: "20px" }}
          >
            <Col span={12}>
              <div className="device-status-container">
                <h3>{this.context.translate("_DRIVER_BEHAVIOUR_")}</h3>
                <div className="alarm-list">


                  {this.aiDashboardStore.driverData.map((status, index) => (
                    <div className="alarm-item" >
                      <div className="d-flex gap-2 align-items-center">
                        <div className="inblueline"></div>
                        <span className="alarm-label">{status.driverName}</span>
                      </div>
                      <span className="alarm-count">{status.count}</span>
                    </div>
                  ))}




                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="device-alarmrank-container">
                <h3>
                  {this.context.translate("_FLEET_REPORTS_FLEETREPORT_MAXSPEED_")}
                </h3>

                <div className="chart-scroll-wrapper">
                  <Column {...maxSpeedGraph} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Spin>
    );
  }
}

AIDashboard.contextType = StoreContext;
export default observer(withRouter(AIDashboard));
